import React from "react";
import { ServerCrash, RefreshCw, Home, WifiOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { motion } from "motion/react";
import logo from "../../assets/logo.png";
import "./ServerDownPage.css";

export default function ServerDownPage() {
  const navigate = useNavigate();

  return (
    <div className="server-down-page">
      <div className="server-down-grid" />

      <motion.div
        className="server-down-signal"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <motion.span
          animate={{ scale: [1, 1.25, 1], opacity: [0.22, 0, 0.22] }}
          transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.span
          animate={{ scale: [1, 1.45, 1], opacity: [0.18, 0, 0.18] }}
          transition={{
            duration: 2.2,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 0.3,
          }}
        />
        <motion.span
          animate={{ scale: [1, 1.65, 1], opacity: [0.14, 0, 0.14] }}
          transition={{
            duration: 2.2,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 0.6,
          }}
        />
      </motion.div>

      <motion.div
        className="server-down-card"
        initial={{ opacity: 0, y: 34, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.75, ease: [0.16, 1, 0.3, 1] }}
      >
        <motion.img
          src={logo}
          alt="LEG-UP"
          className="server-down-card__logo"
          initial={{ opacity: 0, y: -14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.55 }}
        />

        <div className="server-down-card__visual">
          <motion.div
            className="server-down-icon-shell"
            animate={{
              y: [0, -4, 0],
              boxShadow: [
                "0 18px 34px rgba(49, 64, 47, 0.12)",
                "0 24px 44px rgba(111, 141, 69, 0.2)",
                "0 18px 34px rgba(49, 64, 47, 0.12)",
              ],
            }}
            transition={{ duration: 2.8, repeat: Infinity, ease: "easeInOut" }}
          >
            <motion.div
              className="server-down-icon-shell__pulse"
              animate={{ scale: [0.85, 1.25], opacity: [0.28, 0] }}
              transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut" }}
            />

            <motion.div
              className="server-down-icon-shell__icon"
              animate={{ rotate: [0, -2, 2, 0] }}
              transition={{
                duration: 2.2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <ServerCrash size={36} />
            </motion.div>

            <motion.span
              className="server-down-icon-shell__scan"
              animate={{ x: ["-120%", "120%"], opacity: [0, 1, 0] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            />

            <motion.span
              className="server-down-icon-shell__bolt"
              animate={{ opacity: [0.25, 1, 0.25], scale: [0.96, 1.05, 0.96] }}
              transition={{
                duration: 1.4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          </motion.div>

          <motion.div
            className="server-down-status-chip"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.45, duration: 0.45 }}
          >
            <WifiOff size={15} />
            Connection lost
          </motion.div>
        </div>
        <motion.h1
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25, duration: 0.55 }}
        >
          Service temporarily unavailable
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.34, duration: 0.55 }}
        >
          We are having trouble connecting to the LEG-UP servers. Please try
          again in a few moments.
        </motion.p>

        <motion.div
          className="server-down-card__actions"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.48, duration: 0.5 }}
        >
          <button type="button" onClick={() => window.location.reload()}>
            <RefreshCw size={17} />
            Try again
          </button>

          <button type="button" onClick={() => navigate("/")}>
            <Home size={17} />
            Go home
          </button>
        </motion.div>
      </motion.div>
    </div>
  );
}
